<template>
  <div :class="{card: true, 'play-card': true, 'no-select': true, 'disabled': disabled}">
    <div class="card-value">{{ value }}</div>
  </div>
</template>

<script>
import '@/css/global.css'

export default {
  name: 'Card',
  props: {
    value: Number,
    disabled: Boolean
  }
}
</script>

<style scoped>
.play-card {
  box-shadow: var(--card-shadow);
  font-size: 5vmin;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform .12s ease, box-shadow .12s ease;
}

.play-card:hover {
  transform: translateY(-4px) scale(1.02);
}

.card-value {
  font-weight: 700;
  font-size: 5vmin;
  color: #0f172a;
}
</style>
